import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cc19f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-primary" }, "Publications", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "http://scholar.google.com/citations?user=I2zX3HAAAAAJ",
      target: "_blank"
    }, "Google Scholar")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://arxiv.org/search/cond-mat?searchtype=author&query=Sumita%2C+Shuntaro",
      target: "_blank"
    }, "arXiv")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav nav-tabs",
  id: "tab-pub",
  role: "tablist"
}, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link active",
    id: "tab-pub-paper",
    "data-bs-toggle": "tab",
    href: "#panel-pub-paper",
    role: "tab",
    "aria-controls": "panel-pub-paper",
    "aria-selected": "true"
  }, "Original Paper"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link",
    id: "tab-pub-review",
    "data-bs-toggle": "tab",
    href: "#panel-pub-review",
    role: "tab",
    "aria-controls": "panel-pub-review",
    "aria-selected": "false"
  }, "Review Paper"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link",
    id: "tab-pub-book",
    "data-bs-toggle": "tab",
    href: "#panel-pub-book",
    role: "tab",
    "aria-controls": "panel-pub-book",
    "aria-selected": "false"
  }, "Book"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-item nav-link",
    id: "tab-pub-thesis",
    "data-bs-toggle": "tab",
    href: "#panel-pub-thesis",
    role: "tab",
    "aria-controls": "panel-pub-thesis",
    "aria-selected": "false"
  }, "Thesis")
], -1))
const _hoisted_6 = {
  class: "tab-content",
  id: "panel-pub"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OriginalPaper = _resolveComponent("OriginalPaper")!
  const _component_ReviewPaper = _resolveComponent("ReviewPaper")!
  const _component_BookList = _resolveComponent("BookList")!
  const _component_ThesisList = _resolveComponent("ThesisList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_OriginalPaper),
        _createVNode(_component_ReviewPaper),
        _createVNode(_component_BookList),
        _createVNode(_component_ThesisList)
      ])
    ])
  ]))
}